module.exports = __webpack_public_path__ + "img/info.431f5922.svg";